export const THRESHOLD = 80;

export const flexColReverse = 'flex flex-col-reverse flex-nowrap h-full';
